import { useEffect, useState } from "react";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import {
  SettingsStyles,
  SectionStyles,
} from "../components/Settings/SettingsStyles";
import { Modal, ListItemIcon, ListItemText } from "@mui/material";
import TermsPrivacyModal from "../components/TermsPrivacyModal";
import { TermsAndPrivacy } from "../components/Nav/Drawers/RightDrawer/RightDrawerContent";
import FeedbackIcon from "@mui/icons-material/Feedback";
import FeedbackFormModal from "../components/Settings/FeedbackFormModal";
import { useLocation } from "react-router";
import { useIsDarkMode } from "store/atoms";

export default function HelpAndFeedbackPage() {
  const { pathname } = useLocation();
  const [termsPrivacySrc, setTermsPrivacySrc] = useState("");
  const [allowCloseModal, setAllowCloseModal] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  // close modal on navigate
  const [prevPathname, setPrevPathname] = useState("");
  useEffect(() => {
    if (prevPathname !== pathname) {
      setTermsPrivacySrc("");
    }
    return () => setPrevPathname(pathname);
  }, [prevPathname, pathname]);
  const onLinkClick = address => {
    setTermsPrivacySrc(address);
    // prevent the modal from self-closing on click-open
    setTimeout(() => setAllowCloseModal(true), 500);
  };
  const [isDarkMode] = useIsDarkMode();
  return (
    <SettingsStyles $isDarkMode={isDarkMode}>
      <div className="settingsWrapper helpAndFeedbackWrapper">
        <SectionStyles>
          <List>
            <ListItem
              button={true}
              className="btnFeedback"
              onClick={() => {
                setIsFeedbackOpen(true);
              }}
            >
              <ListItemIcon>
                <FeedbackIcon />
              </ListItemIcon>
              <ListItemText primary={"Feedback"} />
            </ListItem>
          </List>
          <Divider className="alwaysVisible" />
          <List>
            <ListItem className="termsAndPrivacy">
              <TermsAndPrivacy onLinkClick={onLinkClick} />
            </ListItem>
          </List>
        </SectionStyles>
      </div>
      <Modal
        open={!!termsPrivacySrc}
        BackdropProps={{
          onClick: () => {
            if (allowCloseModal) {
              setTermsPrivacySrc("");
              setAllowCloseModal(false);
            }
          },
        }}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <TermsPrivacyModal
            src={termsPrivacySrc}
            setTermsPrivacySrc={setTermsPrivacySrc}
          />
        </div>
      </Modal>
      <Modal
        open={true}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none",
        }}
        BackdropProps={{
          open: true,
          invisible: !isFeedbackOpen,
          style: { transition: "all 0.5s ease" },
        }}
      >
        <div>
          <FeedbackFormModal
            isFeedbackOpen={isFeedbackOpen}
            setIsFeedbackOpen={setIsFeedbackOpen}
          />
        </div>
      </Modal>
    </SettingsStyles>
  );
}
